import api from '../api/axios';

export interface InvoiceItem {
  id?: number;
  invoice?: number;
  product?: number; // Optional for custom products
  description?: string;
  quantity: number;
  unitPrice: number;
  discount?: number;
  tax?: number;
  total: number;
}

export interface Invoice {
  id?: number;
  invoiceNumber: string;
  customer?: number;
  customerName?: string; // For custom customer names
  insuranceClient?: number;
  serviceProvider?: number;
  insuranceCompany?: string;
  salesOrder?: number;
  invoiceDate: string;
  dueDate: string;
  subtotal: number;
  tax: number;
  discount: number;
  total: number;
  paidAmount: number;
  balanceDue: number;
  status?: 'draft' | 'sent' | 'paid' | 'partiallyPaid' | 'overdue' | 'cancelled';
  invoiceType?: 'insurance' | 'service_provider' | 'customer' | 'insurance_customer' | 'service_provider_to_darb';
  taxRate?: number;
  other?: number;
  omTax?: number;
  omanTaxId?: string;
  notes?: string;
  createdBy?: number;
}

const InvoiceService = {
  getAll: (params?: any) => api.get('/invoices', { params }),
  getNextNumber: () => api.get<{ data: { invoiceNumber: string } }>('/invoices/next-number'),
  getOne: (id: number, params?: any) =>
    api.get(`/invoices/${id}`, {
      params: params || {
        'populate[customer]': true,
        'populate[insuranceClient]': true,
        'populate[serviceProvider]': true,
        'populate[salesOrder]': true,
        'populate[createdBy]': true,
      },
    }),
  create: (data: Invoice) => api.post('/invoices', { data }),
  update: (id: number, data: Partial<Invoice>) => 
    api.put(`/invoices/${id}`, { data }),
  delete: (id: number) => api.delete(`/invoices/${id}`),
  
  // Invoice Items
  getItems: (invoiceId: number) =>
    api.get('/invoice-items', {
      params: {
        'filters[invoice][id][$eq]': invoiceId,
        populate: 'product',
      },
    }),
  createItem: (data: InvoiceItem) => api.post('/invoice-items', { data }),
  updateItem: (id: number, data: Partial<InvoiceItem>) =>
    api.put(`/invoice-items/${id}`, { data }),
  deleteItem: (id: number) => api.delete(`/invoice-items/${id}`),
};

export default InvoiceService;
